import React, { useEffect, useState } from "react";
import clone from "lodash.clonedeep";
import { Button, Col, ControlLabel, FormControl, FormGroup, Modal, Row } from "react-bootstrap";
import { initialPartnerModel } from "../models";
import { LINK, TITLE_EN, TITLE_RU } from '../constants';
import ImageSettings from "../../../UI/Settings/CPSettingUploadImage";
import { availableTypesLogo } from "../../EventSettings/models";

const PartnerEditModals = ({
    editablePartner,
    show,
    onSave,
    onUpdate,
    onClose,
}) => {
    const [model, setModel] = useState(null);
    const [showError, setShowError] = useState(false);

    useEffect(() => {
        setModel(editablePartner ?? clone(initialPartnerModel))
    }, [editablePartner]);

    const handleChange = (key, value) => {
        setModel((prevState) => ({
            ...prevState,
            [key]: value,
        }))
    };

    const handleUploadLogo = (value) => {
        const {logoPath} = value;
        handleChange('logoPath', logoPath);
    };

    const handleSave = () => {
        if (!model[TITLE_RU] || !model[TITLE_EN]) {
            setShowError(true);

            return;
        }

        editablePartner ? onUpdate(model) : onSave(model);
        setModel(clone(initialPartnerModel));
        setShowError(false);
        onClose();
    };

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Body>
                <Row>
                    <Col xs={6}>
                        <FormGroup>
                            <ControlLabel>Название RU</ControlLabel>
                            <FormControl
                                value={model?.titleRu || ''}
                                type="text"
                                onChange={(e) => handleChange(TITLE_RU, e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col xs={6}>
                        <FormGroup>
                            <ControlLabel>Название EN</ControlLabel>
                            <FormControl
                                value={model?.titleEn || ''}
                                type="text"
                                onChange={(e) => handleChange(TITLE_EN, e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                {
                    showError &&
                    <Row>
                        <Col xs={12}>
                            <p>
                                <i style={{color: 'red'}}>
                                    Укажите имя или название партнера
                                </i>
                            </p>
                        </Col>
                    </Row>
                }
                <Row>
                    <Col xs={12}>
                        <FormGroup>
                            <ControlLabel>Ссылка</ControlLabel>
                            <FormControl
                                value={model?.link || ''}
                                placeholder="https://"
                                type="text"
                                onChange={(e) => handleChange(LINK, e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <ImageSettings
                            eventImage={model?.logoUrl || ''}
                            title="Логотип"
                            settingName="logoPath"
                            tooltipText="Формат файла - .svg или .png"
                            availableTypes={availableTypesLogo}
                            maxHeight="40px"
                            fixtedCropper
                            cropperWidth={400}
                            cropperHeight={144}
                            onUpdate={handleUploadLogo}
                        />
                    </Col>
                </Row>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    bsStyle="success"
                    onClick={handleSave}
                >
                    Сохранить
                </Button>
                <Button onClick={onClose}>
                    Отменить
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PartnerEditModals;
